class PageContentGenericController {

    constructor(markdownService) {
        this.marked = markdownService;
    }

    $onInit () {
        this.pageHasText();
    }

    pageHasText () {
        if (['register'].indexOf(this.page.page) > -1){
            this.textFields = [
                {
                    field: 'text',
                    description: 'Email text'
                }
            ];
        }
        if (['bookingconfirm'].indexOf(this.page.page) > -1){
            this.textFields = [
                {
                    field: 'pre-detail',
                    description: 'Pre-detail text'
                }, 
                {
                    field: 'post-detail',
                    description: 'Post-detail text'
                }
            ];
        }
    }
}

PageContentGenericController.$inject = ['markdownService'];

export default PageContentGenericController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/pageContent/controllers/pageContent.generic.controller.js